import React, {Component} from 'react';
import {NavItem,Dropdown, DropdownToggle, DropdownMenu} from 'reactstrap';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import LogoutLink from '../../components/user/logoutLink'


class LoginLink extends Component {
  constructor(props) {
    super(props);

      this.state = {
        dropdownOpen: false,
        selectedOption: null,
      };
    }
     toggleDropdown = () => {
      this.setState((prevState) => ({
        dropdownOpen: !prevState.dropdownOpen,
      }));
    };

     handleSelect = (option) => {
      this.setState({
        selectedOption: option,
        dropdownOpen: false,
      });
    };

  render() {
    let {login} = this.props.userState
    const { dropdownOpen } = this.state;

    return (
      <NavItem className="nav-item-link">
        {login.isLogin ?
        <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropdown} className="logout">
          <DropdownToggle caret>
            <i className="fas fa-user"></i>&nbsp;&nbsp; Mon compte
          </DropdownToggle>
          <DropdownMenu>
            <Link className="nav-link user" style={{color:"#000"}} to='/user'>Mon profil</Link>
            <LogoutLink />
          </DropdownMenu>
        </Dropdown>
        :
        <Link className="nav-link user" to='/login'><i className="fas fa-user"></i>&nbsp;&nbsp;Connexion</Link>
      }
      </NavItem>
    )
  }
}


function mapStateToProps({userReducer}) {
  return {
    userState: userReducer
  }
}

export default connect(mapStateToProps)(LoginLink);


// WEBPACK FOOTER //
// ./src/components/user/loginLink.js